import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { SolanaWalletAccount } from '../SolanaWalletAccount.types';

/**
 * Type guard function to check if a wallet account is a Solana wallet account.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account is a Solana wallet account, false otherwise.
 */
export const isSolanaWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is SolanaWalletAccount => walletAccount.chain === 'SOL';
